export function PilotWalkthroughBriefing() {
  return (
    <section className="panel pilot-briefing" aria-labelledby="pilot-briefing-title">
      <p className="eyebrow">TRAINING WALKTHROUGH · SYNTHETIC DATA ONLY</p>
      <h2 id="pilot-briefing-title">Learn the workflow before any live pilot</h2>
      <p className="pilot-briefing__warning">
        This session is not authorized for live customer work. Do not enter real customer or server files,
        case details, documents, personal data, credentials, or payment information.
      </p>
      <p>
        Use the synthetic examples to learn your role-based workflow, follow how test information moves through
        ProFenz, and identify operational or usability problems before a separately approved limited live pilot.
      </p>
      <div className="pilot-briefing__grid">
        <div>
          <h3>What to do</h3>
          <ul>
            <li>Explore the steps available to your assigned role.</li>
            <li>Observe the synthetic data flow without treating it as a real matter.</li>
            <li>Ask questions whenever the next step is unclear.</li>
          </ul>
        </div>
        <div>
          <h3>What to tell us</h3>
          <ul>
            <li>What you hate, find frustrating, confusing, slow, or unnecessary.</li>
            <li>What you like and any “wow” moment that feels especially valuable.</li>
            <li>What is missing or should change before limited live use.</li>
          </ul>
        </div>
      </div>
      <p>
        Use <strong>Review me now</strong> on the current step for pilot-development feedback. It is not a support
        escalation unless the issue genuinely needs human intervention.
      </p>
    </section>
  );
}
